<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/159ugRj/tc-custom/9781571318879.jpg?1705026267246" alt="This image is the cover for the book Siege 13"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Siege 13
      </h1>
      <p class="bookDescription body article font2">
        <b>Stories exploring a world of ordinary people caught between the pincers of aggressors, leading to actions at once deplorable, perplexing, and heroic.</b><br/><br/>In the fall of 1944, the Red Army encircled Budapest, surrounding tens of thousands of German and Hungarian troops, and nearly a million civilians. The ensuing months witnessed one of the most brutal sieges of World War II, with block-to-block guerilla warfare followed by widespread disease, starvation, and unspeakable atrocities. Richly grounded in this historical trauma and its extended aftermath, the stories in <i>Siege 13</i> alternate between the siege itself and a contemporary community of Hungarian émigrés who find refuge in the West.<br/><br/>Illuminating the horror and absurdity of war with wit and subtlety, Tamas Dobozy explores a world in which right and wrong are not easily distinguished, and a gruesome past manifests itself in perplexing, often comical ways.<br/><br/><b>Winner of the Rogers Writers’ Trust Fiction Prize</b><br/><br/><b>Praise for <i>Siege 13</i></b><br/><br/>“Alice Munro . . . Isaac Babel . . . Those comparisons may sound daunting, but Dobozy has mastered the technical conventions of his craft . . . This vivid rendering of Hungarian history as a nightmare from which no one quite wants to awake is Dobozy’s finest achievement.” —Garth Risk Hallberg, <i>The New York Times Book Review</i><br/><br/>“The sheer variety of Dobozy’s approaches to telling stories, and his commitment not only to provoke thought but to entertain, constitute a virtuoso performance. <i>Siege 13</i> is without question one of my favorite story collections ever.” —Jeff VanderMeer, <i>The Washington Post</i><br/><br/>“A superb collection of short stories that revisits two of the deadliest months in Hungarian history. The book tells the stories of those who hid, those who fought, those who betrayed, those who escaped and those who died, and how the effects of the siege still linger, three-quarters of a century later. . . . <i>Siege 13</i> is one of the best books of the year.” —Mark Medley, <i>National Post</i> (Canada)
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Tamas Dobozy
      </h2>
      
      <p class="authorDescription body article">Tamas Dobozy is the author of "Last Notes: And Other Stories" (Arcade, 2002), named a top fiction title by "The Globe and Mail" and "When X Equals Marylou" (Arsenal Pulp, 2003). His work has appeared in "Granta 107, The Raritan Review, One Story, The Chicago Review, Northwest Review, Alaska Quarterly Review, "and elsewhere. His works have also been anthologized in "The Best American Nonrequired Reading 2010," and he was awarded an O. Henry Prize. Born and raised in Canada by Hungarian-born parents, Dobozy was previously a Fulbright Scholar in Creative Writing at New York University, and he now teaches at Wilfrid Laurier University and lives in Ontario, Canada.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Milkweed Editions
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2f58f562